var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "PaymentMethodDeleteModal" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("footer", { staticClass: "form-wrapper-footer" }, [
      _c(
        "button",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.isDeletingProcessing,
              expression: "isDeletingProcessing"
            }
          ],
          class: ["form-wrapper-footer-button", "danger-btn"],
          style: { width: "40%", marginRight: "1rem" },
          on: { click: _vm.cancle }
        },
        [_vm._v("\n        Delete\n      ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          class: [
            "form-wrapper-footer-button",
            "primary-btn",
            false && "ie-spinner"
          ],
          style: { width: "40%" },
          on: { click: _vm.back }
        },
        [_vm._v("\n        Back\n      ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "flex justify-content space-between mt-5 pt-5" },
      [
        _c("h3", { staticClass: "form-wrapper-body-title" }, [
          _vm._v("Delete Payment Method")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "PaymentMethodDeleteModal__warning" }, [
          _vm._v(
            "\n      Are you sure you want to delete this payment method?\n    "
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7aaa4f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7aaa4f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/PaymentMethodDeleteModal.vue
// module id = null
// module chunks = 